@if (tabs().length) {
  <div class="tabs-container">
    <ul class="tab-list">
      @for (tab of tabs(); track tab; let tabIndex = $index) {
        <li
          class="tab-item"
          [class.active]="tab.isActive"
          [style.color]="tab.isActive ? config()?.textColor || '' : config()?.inactiveTextColor || ''"
          [style.backgroundColor]="tab.isActive ? config()?.activeBackgroundColor || '' : ''"
          (click)="selectTab(tabIndex)"
          (keydown.enter)="selectTab(tabIndex)">
          {{ tab.tabTitle() }}
        </li>
      }
    </ul>
    <div
      class="tab-content-wrapper"
      [ngClass]="{ 'top-left-tab-radius': !tabs().at(0)!.isActive }"
      [style.backgroundColor]="config()?.contentBackgroundColor || ''">
      <ng-content></ng-content>
    </div>
  </div>
}
